import React, {PureComponent} from "react"
import PropTypes from "prop-types"

import {getOptimalInfoWindowProperties} from "@irati-web/geolocation/src/helpers/infoWindow"

import {Container, StyledMarker, StyledInfoWindow} from "./styled/LocationMarker"

class LocationMarker extends PureComponent {
  static propTypes = {
    index: PropTypes.number.isRequired,
    uuid: PropTypes.string.isRequired,
    onClick: PropTypes.func,
    isActive: PropTypes.bool,
    zIndex: PropTypes.number,
    boundingBox: PropTypes.arrayOf(PropTypes.number),
    lat: PropTypes.number.isRequired,
    lng: PropTypes.number.isRequired,
    streetAddress: PropTypes.string.isRequired,
    city: PropTypes.string.isRequired,
    postCode: PropTypes.string.isRequired
  }

  static defaultProps = {
    onClick: () => {},
    isActive: false,
    zIndex: 1,
    boundingBox: null
  }

  render() {
    const {uuid, onClick, isActive, zIndex, lat, lng, boundingBox, streetAddress, city, postCode} = this.props
    if (!boundingBox) { return null }
    const {position, arrowPosition} = getOptimalInfoWindowProperties(boundingBox, {lat, lng})
    return (
      <Container>
        <StyledMarker isActive={isActive} zIndex={zIndex} onClick={() => { onClick(uuid) }} />
        {isActive && (
          <StyledInfoWindow
            position={position}
            arrowPosition={arrowPosition}
            zIndex={zIndex}
            streetAddress={streetAddress}
            city={city}
            postCode={postCode} />
        )}
      </Container>
    )
  }
}

export default LocationMarker
